var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.alert.id === "44"
      ? _c("div", { staticStyle: { "font-transform": "italic" } }, [
          _c("div", { staticClass: "meta-item" }, [
            _c("span", { staticClass: "meta-name has-text-weight-bold" }, [
              _vm._v("Beca/Crédito:")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "meta-value" }, [
              _vm._v(_vm._s(_vm.alert.becaDescripcion || ""))
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "meta-item" }, [
            _c("span", { staticClass: "meta-name has-text-weight-bold" }, [
              _vm._v("Valor beca/crédito:")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "meta-value" }, [
              _vm._v(_vm._s(_vm.alert.becaValor || ""))
            ]),
            _vm._v(" "),
            _vm.alert.becaValor === 0 ? _c("span", [_vm._v("0")]) : _vm._e()
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "meta-item" }, [
            _c("span", { staticClass: "meta-name has-text-weight-bold" }, [
              _vm._v("Procentaje de cobertura de la beca/crédito:")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "meta-value" }, [
              _vm._v(
                _vm._s(_vm.humanizePercentage(_vm.alert.becaCobertura) || "")
              )
            ])
          ])
        ])
      : _c("div", { staticStyle: { "font-transform": "italic" } }, [
          _c("div", { staticClass: "meta-item" }, [
            _c("span", { staticClass: "meta-name has-text-weight-bold" }, [
              _vm._v(_vm._s(_vm.getTitle()))
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "meta-value" }, [
              _vm._v(_vm._s(_vm.getValue()))
            ])
          ])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }